var _a, _b;
import { TipoRequerenteEnum } from './TipoRequerenteEnum';
export var TipoDocumentoEnum;
(function (TipoDocumentoEnum) {
    TipoDocumentoEnum["PJ"] = "PJ";
    TipoDocumentoEnum["PF"] = "PF";
})(TipoDocumentoEnum || (TipoDocumentoEnum = {}));
export var TipoDocumentoOptions = {
    mapDescricao: (_a = {},
        _a[TipoDocumentoEnum.PF] = 'Pessoa Física',
        _a[TipoDocumentoEnum.PJ] = 'Pessoa Jurídica',
        _a),
    mapTipoRequerente: (_b = {},
        _b[TipoDocumentoEnum.PF] = TipoRequerenteEnum.PESSOA_FISICA,
        _b[TipoDocumentoEnum.PJ] = TipoRequerenteEnum.PESSOA_JURIDICA,
        _b),
    getDescricao: function (key) {
        return this.mapDescricao[key];
    },
    getTipoRequerente: function (key) {
        return this.mapTipoRequerente[key];
    },
    getOptions: function () {
        return Object.entries(this.mapDescricao).map(function (_a) {
            var value = _a[0], label = _a[1];
            return ({
                label: label,
                value: value,
            });
        });
    },
};
